import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { DriverLocation } from "@/reducers/locationsSlice"
import LocationParser from "@/lib/locationParser"
import { recordLocationSubscribeResult } from "@/lib/locationSubscriptionTracker"

const NODE = "http://jabber.org/protocol/geoloc"

export const retrieveAllDriverLocations = async (
  xmpp: Client,
): Promise<DriverLocation[]> => {
  const driverLocations = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    timeout: 40000,
  })

  const items = driverLocations
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as [Element]

  return items.map((item) => {
    const geoloc = item.getChild("geoloc", "http://jabber.org/protocol/geoloc")
    const location = geoloc ? LocationParser.parseGeoloc(geoloc) : undefined
    return {
      jid: item.getAttr("id") as string,
      location,
    }
  })
}

export const subscribeToLocations = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(window.XMPP!, wizardJid(client.jid!), NODE)
    recordLocationSubscribeResult("ok")
  } catch (error: any) {
    if (error.condition === "item-not-found") {
      recordLocationSubscribeResult("item-not-found")
    } else {
      recordLocationSubscribeResult("error")
      console.warn(`Error subscribing to ${NODE}`, error)
    }
  }
}
